import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const SECTIONS = [
  {
    title: 'Siti web e link di terze parti',
    body: [
      "I Servizi potrebbero presentare link a siti web o ad altre piattaforme online gestiti da terze parti. Se apri link a siti non affiliati o non controllati da noi, potresti dover accettare le loro informative sulla privacy e la sicurezza e altri termini e condizioni. Non garantiamo né siamo responsabili per la privacy e la sicurezza di tali siti, né della correttezza, della veridicità e dell'affidabilità delle informazioni in essi contenute.",
      "Le informazioni che fornisci in contesti pubblici o semi-pubblici, comprese quelle che condividi su piattaforme social di terze parti, potrebbero essere visualizzate anche da altri utenti dei Servizi e/o dagli utenti delle suddette piattaforme di terze parti, senza restrizioni al loro utilizzo da parte nostra o di terze parti. Il fatto che includiamo tali link non implica alcun sostegno da parte nostra nei confronti dei contenuti di tali piattaforme né dei loro proprietari o gestori, fatta eccezione per quanto divulgato nei Servizi.",
    ],
  },
  {
    title: 'Dati dei minori',
    body: [
      "I Servizi non sono adatti all'utilizzo da parte di minori e noi non raccogliamo di proposito i dati personali di bambini al di sotto della maggiore età nella tua giurisdizione. Se sei un genitore o un tutore di un minore che ci ha fornito i propri dati personali, puoi contattarci utilizzando i recapiti indicati di seguito per chiederne l'eliminazione.",
      "A partire dalla data di entrata in vigore della presente Informativa sulla privacy, non siamo a conoscenza della \"condivisione\" o \"vendita\" (a seconda di come tali termini sono indicati nelle leggi applicabili) dei dati personali di soggetti di età inferiore ai 16 anni.",
    ],
  },
  {
    title: 'Sicurezza e conservazione dei dati',
    body: [
      "Tieni presente che nessuna misura di sicurezza è perfetta né impenetrabile e che non possiamo garantire una \"sicurezza assoluta\". Inoltre, i dati che ci invii potrebbero non essere sicuri durante l'invio. Ti consigliamo di utilizzare solo canali sicuri per comunicarci informazioni riservate o confidenziali.",
      "Il tempo di conservazione dei dati personali dipende da diversi fattori, come ad esempio se abbiamo bisogno di tali dati per mantenere il tuo account, per fornirti i Servizi, adempiere agli obblighi legali, risolvere dispute o applicare altri contratti e informative.",
    ],
  },
  {
    title: 'Diritti e scelte a tua disposizione',
    body: [
      "A seconda di dove risiedi, potresti godere di uno o più diritti relativi ai dati personali, tra quelli elencati di seguito. Tuttavia, tali diritti non sono assoluti e potrebbero valere solo in determinate circostanze e può capitare che rifiutiamo la tua richiesta nei limiti di quanto consentito dalla legge.",
    ],
    list: [
      "Diritto di accesso/conoscenza. Potresti avere il diritto di richiedere l'accesso ai tuoi dati personali in nostro possesso.",
      "Diritto di eliminazione. Potresti avere il diritto di richiedere l'eliminazione dei tuoi dati personali in nostro possesso.",
      "Diritto di correzione. Potresti avere il diritto di richiedere la correzione dei tuoi dati personali in nostro possesso.",
      "Diritto di portabilità. Potresti avere il diritto di ricevere una copia dei tuoi dati personali in nostro possesso e di chiederci di trasferirli a una terza parte, in determinate circostanze e con determinate eccezioni.",
      "Gestione delle preferenze di comunicazione. Potremmo inviarti email promozionali e tu puoi rifiutare esplicitamente di riceverle in qualsiasi momento utilizzando l'opzione di annullamento dell'iscrizione presente nelle nostre email. Se rifiuti esplicitamente, potremmo comunque inviarti email non promozionali, come quelle relative al tuo account o agli ordini da te effettuati.",
    ],
    after: [
      "Se risiedi nel Regno Unito o nello Spazio economico europeo, e in relazione alle restrizioni e ai limiti imposti dalle leggi locali, potresti esercitare i seguenti diritti oltre a quelli menzionati in precedenza:",
    ],
    list2: [
      "Opposizione all'elaborazione e limitazione dell'elaborazione: Potresti avere il diritto di chiederci di interrompere o limitare l'elaborazione dei dati personali per determinate finalità.",
      "Revoca del consenso: Qualora sia necessario il tuo consenso per elaborare i tuoi dati personali, hai il diritto di revocarlo. Se revochi tale consenso, ciò non influirà sulla legittimità dell'elaborazione basata sul tuo consenso prima della revoca.",
    ],
    after2: [
      "Potresti esercitare qualsiasi di tali diritti ove indicato nei Servizi o contattandoci tramite i recapiti indicati di seguito. Per maggiori informazioni su come Shopify utilizza i tuoi dati personali e i tuoi eventuali diritti, compresi quelli relativi ai dati elaborati da Shopify stesso, puoi visitare https://privacy.shopify.com/en.",
      "Non subirai alcuna discriminazione per aver esercitato tali diritti. Prima di elaborare le tue richieste potrebbe essere necessario verificare la tua identità, entro i limiti consentiti dalle leggi in vigore. In conformità alle leggi applicabili, puoi nominare un agente autorizzato che effettui le richieste per conto tuo al fine di esercitare i tuoi diritti.",
    ],
  },
  {
    title: 'Reclami',
    body: [
      "In caso di reclami su come elaboriamo i tuoi dati personali, contattaci tramite i recapiti indicati di seguito. A seconda di dove risiedi, potresti avere il diritto di fare ricorso contro la nostra decisione contattandoci tramite i recapiti indicati di seguito, o di riferire il tuo reclamo all'autorità locale responsabile della protezione dei dati.",
    ],
  },
  {
    title: 'Trasferimenti internazionali',
    body: [
      "Tieni presente che potremmo trasferire, conservare ed elaborare i tuoi dati personali al di fuori del paese in cui risiedi.",
      "In caso di trasferimento dei tuoi dati personali al di fuori dello Spazio economico europeo o del Regno Unito, ci affideremo a meccanismi di trasferimento affidabili, come le Clausole contrattuali tipo della Commissione europea, o di contratti equivalenti erogati dalle autorità competenti del Regno Unito, a meno che il trasferimento di dati non avvenga verso un paese che si ritenga fornisca un adeguato livello di protezione.",
    ],
  },
  {
    title: 'Modifiche alla presente Informativa sulla privacy',
    body: [
      "Aggiorneremo la presente Informativa sulla privacy di tanto in tanto, anche per riflettere le modifiche alle nostre pratiche o per altre finalità operative, legali o normative. Pubblicheremo l'Informativa sulla privacy aggiornata sul sito web, modificheremo la data dell'\"Ultimo aggiornamento\" ed emaneremo un avviso secondo quanto stabilito dalle leggi in vigore.",
    ],
  },
];

export default function InformativeGenerali() {
  return (
    <main data-testid="informative-generali-page" className="bg-essenya-bg">
      <section className="section-padding">
        <div className="container-essenya max-w-3xl">
          <div className="text-eyebrow mb-3">Informative generali</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium mb-4">Informativa sulla privacy</h1>
          <p className="text-essenya-text text-lg mb-12">
            La tua fiducia è importante per noi. Di seguito trovi le informazioni generali su come trattiamo i dati e sui termini relativi all'utilizzo dei nostri Servizi.
          </p>

          <div className="space-y-10">
            {SECTIONS.map((s, i) => (
              <div key={i} data-testid={`info-section-${i}`} className="border-t border-essenya-border pt-8">
                <h2 className="font-display text-2xl md:text-3xl mb-4">{s.title}</h2>
                <div className="space-y-4 text-essenya-text leading-relaxed">
                  {s.body && s.body.map((p, j) => <p key={j}>{p}</p>)}
                  {s.list && (
                    <ul className="list-disc pl-5 space-y-2">
                      {s.list.map((li, j) => <li key={j}>{li}</li>)}
                    </ul>
                  )}
                  {s.after && s.after.map((p, j) => <p key={j}>{p}</p>)}
                  {s.list2 && (
                    <ul className="list-disc pl-5 space-y-2">
                      {s.list2.map((li, j) => <li key={j}>{li}</li>)}
                    </ul>
                  )}
                  {s.after2 && s.after2.map((p, j) => <p key={j}>{p}</p>)}
                </div>
              </div>
            ))}

            {/* Contatti */}
            <div data-testid="info-section-contatti" className="border-t border-essenya-border pt-8">
              <h2 className="font-display text-2xl md:text-3xl mb-4">Contatti</h2>
              <p className="text-essenya-text leading-relaxed mb-6">
                In caso di domande sulle nostre politiche sulla privacy o sulla presente Informativa sulla privacy,
                o se intendi esercitare qualsiasi diritto che ti spetta, puoi contattarci. Per la finalità delle leggi
                sulla protezione dei dati applicabili, siamo il titolare del trattamento dei tuoi dati personali.
              </p>
              <div className="space-y-3">
                <a href="mailto:luciailaria.pegoli@hotmail.com" data-testid="info-contact-email" className="flex items-center gap-3 text-essenya-ink hover:opacity-70 transition">
                  <Mail size={18} strokeWidth={1.5} /> luciailaria.pegoli@hotmail.com
                </a>
                <div className="flex items-center gap-3 text-essenya-text">
                  <MapPin size={18} strokeWidth={1.5} /> Via privata Democrito 9, Milano, MI, 20127, IT
                </div>
              </div>
              <Link to="/contatti" data-testid="info-contatti-cta" className="btn-secondary mt-8">Vai ai contatti</Link>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
